import { render, staticRenderFns } from "./OwnCompany.vue?vue&type=template&id=575c0fb0&"
import script from "./OwnCompany.vue?vue&type=script&lang=js&"
export * from "./OwnCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports